// Playbox no-op replacement for excalidraw-app/data/firebase.ts.
//
// Upstream Excalidraw uses Firebase for two collab concerns:
//   1. Persisting encrypted room snapshots between sessions
//   2. Storing image files referenced by a room
//
// We run our own backend (api.draw.plbx.ai) for persistence — the host's
// changes are autosaved there via PlbxBoardSync — and the excalidraw-room
// socket relay (draw-ws.plbx.ai) handles realtime peer sync. Firebase is
// unwired.
//
// Collab.tsx tolerates `loadFromFirebase` returning null: it falls back to
// peer-pushed SCENE_INIT broadcasts. `saveToFirebase` returning null is a
// no-op. `isSavedToFirebase` returning true suppresses the unsaved-changes
// unload prompt. File upload/download exports yield empty result sets so
// pasted images that aren't already in our backend simply don't propagate
// across the room (callers already handle that with `erroredFiles`).

import type { FileId } from "@excalidraw/element/types";
import type { BinaryFileData } from "@excalidraw/excalidraw/types";

import type { SyncableExcalidrawElement } from ".";

export const loadFirebaseStorage = async () => null as any;

export const isSavedToFirebase = (
  _portal: unknown,
  _elements: readonly unknown[],
): boolean => true;

export const saveFilesToFirebase = async ({
  files,
}: {
  prefix: string;
  files: { id: FileId; buffer: Uint8Array }[];
}) => {
  // Pretend every upload succeeded so the caller does not retry every tick.
  return {
    savedFiles: files.map((f) => f.id),
    erroredFiles: [] as FileId[],
  };
};

export const saveToFirebase = async (
  _portal: unknown,
  _elements: readonly SyncableExcalidrawElement[],
  _appState: unknown,
): Promise<null> => null;

export const loadFromFirebase = async (
  _roomId: string,
  _roomKey: string,
  _socket: unknown,
): Promise<readonly SyncableExcalidrawElement[] | null> => null;

export const loadFilesFromFirebase = async (
  _prefix: string,
  _decryptionKey: string,
  _filesIds: readonly FileId[],
) => {
  return {
    loadedFiles: [] as BinaryFileData[],
    erroredFiles: new Map<FileId, true>(),
  };
};
